export const VehicleType = {
    List: [
        {value: "01", label: "VMS_REQUEST_VISITOR_VEHICLE_TYPE_CAR"},
        {value: "02", label: "VMS_REQUEST_VISITOR_VEHICLE_TYPE_TRUCK"},
        {value: "03", label: "VMS_REQUEST_VISITOR_VEHICLE_TYPE_MOTORCYCLE"},
        {value: "04", label: "VMS_REQUEST_VISITOR_VEHICLE_TYPE_BUS"},
        {value: "05", label: "VMS_REQUEST_VISITOR_VEHICLE_TYPE_SPECIAL"},
        {value: "99", label: "VMS_REQUEST_VISITOR_VEHICLE_TYPE_OTHER"},
    ],
    Map: new Map<string, string>([
        ['01', 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_CAR'],
        ['02', 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_TRUCK'],
        ['03', 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_MOTORCYCLE'],
        ['04', 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_BUS'],
        ['05', 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_SPECIAL'],
        ['99', 'VMS_REQUEST_VISITOR_VEHICLE_TYPE_OTHER'],
    ]),
    Enum: {
        Car: '01',
        Truck: "02",
        Motorcycle: '03',
        Bus: '04',
        Special: '05',
        Other: '99'
    }
};